import AsyncStorage from "@react-native-async-storage/async-storage";

export const TOOL_PREFERENCE_KEYS = {
  mathModeEnabled: "tool.math_mode_enabled",
  autoReadAloudEnabled: "tool.auto_read_aloud_enabled",
  playbackSpeed: "tool.playback_speed",
} as const;

type ToolPreferenceKey = (typeof TOOL_PREFERENCE_KEYS)[keyof typeof TOOL_PREFERENCE_KEYS];
export type PlaybackSpeed = 0.5 | 0.75 | 1 | 1.25 | 1.5 | 2;
const DEFAULT_PLAYBACK_SPEED: PlaybackSpeed = 1;
const PLAYBACK_SPEED_VALUES: PlaybackSpeed[] = [0.5, 0.75, 1, 1.25, 1.5, 2];

export const saveBooleanToolPreference = async (key: ToolPreferenceKey, enabled: boolean) => {
  try {
    await AsyncStorage.setItem(key, JSON.stringify(enabled));
  } catch (error) {
    console.error("Error saving tool preference:", { key, error });
  }
};

export const getBooleanToolPreference = async (key: ToolPreferenceKey, defaultValue = false): Promise<boolean> => {
  try {
    const value = await AsyncStorage.getItem(key);
    if (value == null) {
      return defaultValue;
    }
    return value === "true";
  } catch (error) {
    console.error("Error getting tool preference:", { key, error });
    return defaultValue;
  }
};

export const savePlaybackSpeedPreference = async (speed: PlaybackSpeed) => {
  try {
    await AsyncStorage.setItem(TOOL_PREFERENCE_KEYS.playbackSpeed, String(speed));
  } catch (error) {
    console.error("Error saving playback speed preference:", { speed, error });
  }
};

export const getPlaybackSpeedPreference = async (
  defaultValue: PlaybackSpeed = DEFAULT_PLAYBACK_SPEED
): Promise<PlaybackSpeed> => {
  try {
    const value = await AsyncStorage.getItem(TOOL_PREFERENCE_KEYS.playbackSpeed);
    if (value == null) {
      return defaultValue;
    }
    const parsed = Number(value);
    if (PLAYBACK_SPEED_VALUES.includes(parsed as PlaybackSpeed)) {
      return parsed as PlaybackSpeed;
    }
    return defaultValue;
  } catch (error) {
    console.error("Error getting playback speed preference:", { error });
    return defaultValue;
  }
};
